import * as React from 'react'
import { connect } from 'react-redux'
import { OptionsType } from 'react-select/lib/types'

import { RootState } from '../store/rootReducer'
import { Location } from '../lib/interfaces/Location.interface'

// import Select from 'react-select'

import CustomSelect from './CustomSelect.component'

import * as appSelectors from '../store/app/selectors'

const map = require('lodash/map')
const sortBy = require('lodash/sortBy')

type SelectType = 'normal' | 'orange'

type LocationSelectProps = {
  style?: any
  value?: number
  type?: SelectType
  isMulti?: boolean
  placeholder?: string
  locations: Location[]
  placeholderStyle?: any
  valueContainerStyle?: any
  hideAllLocationsOption?: boolean
  onChange: (value: number) => void
  getLocationLabel?: (location: Location) => string
}

class LocationSelect extends React.Component<LocationSelectProps> {
  render() {
    const {
      type,
      style,
      value,
      isMulti,
      onChange,
      locations,
      placeholder,
      getLocationLabel,
      placeholderStyle,
      valueContainerStyle,
      hideAllLocationsOption
    } = this.props

    let locationsAsSelectObjects: OptionsType<any> = map(locations, location => ({ value: location.id, label: getLocationLabel ? getLocationLabel(location) : location.code }))
    locationsAsSelectObjects = sortBy(locationsAsSelectObjects, 'label')

    if (!hideAllLocationsOption) {
      (locationsAsSelectObjects as any).splice(0, 0, { value: null, label: 'All locations' })
    }

    return (
      <CustomSelect
        type={type}
        style={style}
        value={value}
        isMulti={isMulti}
        onChange={onChange}
        options={locationsAsSelectObjects}
        placeholderStyle={placeholderStyle}
        valueContainerStyle={valueContainerStyle}
        placeholder={placeholder || 'All locations'}
      />
    )
  }
}

const mapStateToProps = (state: RootState) => ({
  locations: appSelectors.getLocations(state)
})

export default connect(mapStateToProps)(LocationSelect)



// WEBPACK FOOTER //
// ./src/common/LocationSelect.component.tsx